import axios from 'axios';

// search vat input api
export async function searchUnitsAPI(Data) {
	let unitlist = [];
	const unitVal = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/units/search/?unitName=${unitVal}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		unitlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return unitlist;
}

// check existing vat input api
export async function getUnitsAPI(Data) {
	let unitlist = [];
	const unitName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/units/getUnit/?unitName=${unitName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		unitlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return unitlist;
}

//create status api
export async function createUnitsAPI(Data, userID) {
	let unitsData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/units/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		unitsData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return unitsData;
}

//update status api
export async function updateUnitsAPI(Data, unitID, userID) {
	let unitsData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/units/update/?unitID=${unitID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		unitsData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return unitsData;
}